import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-year-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'year-switch.component.html',
})
export class YearSwitchComponent {
  @Input() year: number = new Date().getFullYear();
  @Output() yearChange: EventEmitter<number> = new EventEmitter();

  prevYear() {
    this.year--;
    this.yearChange.emit(this.year);
  }

  nextYear() {
    this.year++;
    this.yearChange.emit(this.year);
  }

  constructor() {}
}
